// extracted by mini-css-extract-plugin
export default {"banner":"_93ea606c","printLink":"_20d88709"};